module.exports = __webpack_public_path__ + "img/profile-cover.d0419065.jpg";